/* eslint
    no-empty-function: "warn",
*/

import { invoke } from '@shared/easyfy.decorators';
import { IEasyfyEvent } from '@shared/easyfy.events/easyfy.eventdata';
import Events, {
  ServiceNames
} from '@shared/easyfy.events/easyfy.eventhandler';
import { MedsEventNames } from './eventMappers/dataMapper.ga4';

namespace Meds.Modules {
  @invoke
  class GAEventListener {
    onInit() {
      GAEventListener.MainMenuOpen();
      GAEventListener.MenuCategorySelected();
    }

    static MainMenuOpen = () => {
      const mainmenu: HTMLElement = document.querySelector<HTMLElement>(
        '[data-target="main-menu"]'
      );
      if (!mainmenu) {
        return;
      }

      mainmenu.addEventListener('click', (e) => {
        const event: IEasyfyEvent = {
          eventName: MedsEventNames.MenuOpen,
          data: {}
        };
        Events.EasyfyEventHandler.RunEvent(event);
      });
    };

    static MenuCategorySelected = () => {
      const categoriesSection: HTMLElement =
        document.querySelector<HTMLElement>('.categories-section');
      const categories = categoriesSection.querySelectorAll<HTMLSelectElement>(
        '[data-menu-category]'
      );

      categories.forEach((category) => {
        category.addEventListener('click', () => {
          if (category.classList.contains('visible')) {
            return;
          }

          const event: IEasyfyEvent = {
            eventName: MedsEventNames.MenuCategorySelect,
            data: {
              category: category.dataset.menuCategory,
              action: category.dataset.event?.includes('toggle')
                ? 'open'
                : 'select'
            }
          };
          Events.EasyfyEventHandler.RunEvent(event);
        });
      });
    };
  }
}
